module.exports = __webpack_public_path__ + "img/HA1509-01.5fe939ce.jpg";